<div class="user-filter-group">
  <!-- same card as the roles in the permissions tab -->
  <section class="card qa-perm-card">
    <div class="card-body">
      <div class="qa-perm-head"><h3>{{_(KEYS.CRUD.FILTER_GROUPS)}}</h3></div>
      <table class="table">
        <thead>
        <tr>
          <th>{{_(KEYS.CRUD.FILTER_GROUP_DESCRIPTION)}}</th>
          <th>{{_(KEYS.CRUD.FILTER_GROUP_ID)}}</th>
          <th class="qa-perm-assign">{{isReadonly ? _(KEYS.CRUD.ASSIGNED) : _(KEYS.CRUD.ASSIGN)}}</th>
        </tr>
        </thead>
        <tbody>
        <ng-container *ngFor="let filterGroup of filterGroups">
          <tr *ngIf="!isReadonly || selectedUserFilterGroups[filterGroup.id]">
            <td class="qa-perm-role">{{filterGroup.name[locale]}}</td>
            <td><span class="qa-fg-id">{{filterGroup.id}}</span></td>
            <td class="qa-perm-assign">
              <input
                type="checkbox"
                class="qa-switch"
                role="switch"
                [attr.aria-label]="filterGroup.name[locale] || filterGroup.id"
                [attr.disabled]="isReadonly? true : null"
                [(ngModel)]="selectedUserFilterGroups[filterGroup.id]"
                (change)="onUpdateUserFilterGroup(filterGroup)">
            </td>
          </tr>
        </ng-container>
        </tbody>
      </table>
    </div>
  </section>
</div>
